import { compose, flattenProp, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { addIntlProps, addProps } from 'utils/recompose';
import formatCurrency from 'utils/formatCurrency';
import messages from './messages';
import {
  inCartTemplate,
  selected,
  locked,
} from 'reducers/inCartTemplates/selectors';
import { modelNameByTemplateId } from 'reducers/inCartModels/selectors';
import { designPackageKeys } from 'reducers/cart/selectors';
import {
  selectTemplateInCart,
  unselectTemplateInCart,
} from 'reducers/inCartTemplates/actions';
import { functionalGroupCodes } from 'reducers/inCartFunctionalGroups/selectors';
import { mini, theme } from 'reducers/dashboard/selectors';
import combineSelectors from 'utils/combineSelectors';
import { join, keys, reduce } from 'lodash';

const mapStateToProps = combineSelectors({
  inCartTemplate,
  modelNameByTemplateId,
  functionalGroupCodes,
  selected,
  locked,
  designPackageKeys,
  mini,
  theme,
});

const formattedTotal = formatCurrency({
  priceProp: 'totalPrice',
  currencyProp: 'currency',
});

export const priorityLabel = ({
  prioritiesToQuantitiesMap,
  priorityString,
}) => {
  let priorities = keys(prioritiesToQuantitiesMap);

  if (priorities.length > 1) {
    let priorityString = join(priorities, ', ');
    return `Multiple ${priorityString}`;
  } else {
    return `${priorityString} ${priorities[0]}`;
  }
};

export const totalQuantity = ({ prioritiesToQuantitiesMap }) => {
  return reduce(
    prioritiesToQuantitiesMap,
    function(result, value, key) {
      return result + value;
    },
    0,
  );
};

export const optionClusterString = ({ functionalGroupCodes }) =>
  functionalGroupCodes.reduce(
    (outputStr, code) => outputStr.concat(`${code} `),
    '',
  );

export const selectTemplate = ({ templateId, selectTemplateInCart }) => () => {
  selectTemplateInCart(templateId);
};

export const selectedTemplate = ({ locked, selected }) => !locked && selected;

export const selectableTemplate = ({ locked, selected }) =>
  !locked && !selected;

export const unselectTemplate = ({
  templateId,
  unselectTemplateInCart,
}) => () => {
  unselectTemplateInCart(templateId);
};

export const modelUrl = ({ modelId, seriesId, templateId }) =>
  `/series/${seriesId}/models/${modelId}#${templateId}`;

export const toggleMoreOptions = ({
  toggleMoreTemplateOptions,
  templateId,
}) => () => toggleMoreTemplateOptions(templateId);

export const editStyle = ({ theme }) => ({ color: theme.palette.primary });

export default compose(
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['priorityString', 'currency', 'editString'],
  }),
  connect(
    mapStateToProps,
    { selectTemplateInCart, unselectTemplateInCart },
  ),
  flattenProp('inCartTemplate'),
  addProps({
    formattedTotal,
    priorityLabel,
    totalQuantity,
    optionClusterString,
    selectedTemplate,
    selectableTemplate,
    modelUrl,
    editStyle,
  }),
  withHandlers({ selectTemplate, unselectTemplate, toggleMoreOptions }),
);
